import { DatePipe } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import * as moment from 'moment';
import {
  LoginModel,
  MainDepartment,
} from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import { WeekColorService } from '../../company-config/WeekColors/services/week-color.service';
import { ProductionCycleSchedule } from '../../company-config/WeekColors/models/week-color.model';

@Component({
  selector: 'app-top-performer',
  templateUrl: './top-performer.component.html',
  styleUrls: ['./top-performer.component.css'],
})
export class TopPerformerComponent {
  @ViewChild('storeTab') storeTab!: ElementRef<HTMLElement>;
  isTableData: boolean = true;
  isLoading: boolean = false;
  showWeeklyOption: boolean = true;
  deptID: number = 0;
  mainDepartmentList: Array<MainDepartment> = [];
  weekData: any = [];
  startDate: any;
  endDate: any;
  dayStartDate: any;
  dayEndDate: any;
  previousStartDate: string | undefined;
  previousEndDate: string | undefined;
  isItemEntry: boolean = false;
  topPerformerTabId: number = 0;
  performance: any;
  performerData: any = [];
  performerData2: any = [];
  performanceCardDaily: any = [];
  performanceCardWeekly: any = [];
  performanceCardMonthly: any = [];
  performanceEmpDaily: any = [];
  performanceEmpWeekly: any = [];
  performanceEmpMonthly: any = [];
  cycleId: number = 0;
  periodId: number = 1;
  isEmpCard: boolean = false;
  deptDataFetchCount: number = 0;
  imgArray = [
    'assets/dashboard/img_storeTopPerformer1.svg',
    'assets/dashboard/img_storeTopPerformer2.svg',
    'assets/dashboard/img_storeTopPerformer3.svg',
  ];
  icArray = [
    'assets/dashboard/ic_topPerformer1.svg',
    'assets/dashboard/ic_topPerformer2.svg',
    'assets/dashboard/ic_topPerformer3.svg',
  ];
  empImgArray = [
    'assets/dashboard/img_topPerformer1.svg',
    'assets/dashboard/img_topPerformer2.svg',
    'assets/dashboard/img_topPerformer3.svg',
  ];
  empCardPerformer: boolean = false;
  storeCardPerformer: boolean = false;
  userInfo: LoginModel = new LoginModel();
  weekColorSchedule: Array<ProductionCycleSchedule> = [];
  periodArray: {
    value: number;
    name: string;
    startDate: string;
    endDate: string;
  }[] = [];
  periodDayArray: {
    value: number;
    name: string;
    startDate: string;
    endDate: string;
  }[] = [];
  periodWeekArray: {
    value: number;
    name: string;
    startDate: string;
    endDate: string;
    prevStartDate: string;
    prevEndDate: string;
  }[] = [];
  reportHasRun: boolean = false;
  private isDataInitialized = false;
  private lastUpdateTime: number = 0;
  private readonly UPDATE_THRESHOLD = 1000;
  constructor(
    private masterservice: MasterDataSeriveService,
    private datepipe: DatePipe,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private weekColorService: WeekColorService
  ) { }

  async ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      { crumbName: 'Top Performer', link: '/admin/home/top-performer' },
    ]);

    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    const productionScheduleType = (this.userInfo as any)?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeeklyOption = productionScheduleType !== 'datespecific';
    if (!this.showWeeklyOption && this.periodId === 2) {
      this.periodId = 1;
    }
    this.startDate = moment().subtract(1, 'days');
    this.endDate = moment();
    await this.initializeData();
  }

  private async initializeData(): Promise<void> {
    if (this.isDataInitialized) {
      return;
    }

    try {
      this.getMainDepartments();
      this.selectPeriod();
      this.isDataInitialized = true;
    } catch (error) {
      console.error('Error initializing data:', error);
    }
  }
  topPerformerTabChange(value: number) {
    this.topPerformerTabId = value;
    // Switching tabs must not auto-fetch. Only the tab/UI state is updated here;
    // the user must click Run Report to (re)load data for the selected tab.
    if (!this.isTableData) {
      if (value) {
        this.empCardPerformer = false;
        this.isEmpCard = true;
      } else {
        this.empCardPerformer = true;
      }
    }
  }

 async toggleTableOrGraph(flag: boolean) {
    if (this.storeTab) {
      this.storeTab.nativeElement.click();
    }
    this.isTableData = flag;
    // Switching between table and graph must not auto-fetch. The user must click
    // Run Report to load data for the newly selected view. State is preserved.
    this.topPerformerTabChange(0);
  }

  /* Builds the period selectors and loads the card-view (graph) data. */
  private async loadCardData(): Promise<void> {
    await this.getDays();
    if (this.showWeeklyOption) {
      await this.getWeeks();
      if (this.cycleId == 0 || this.cycleId == undefined) {
        await this.getProductionCycle();
      }
    }
    await this.getMonths();
    await this.initialCardDailyData();
    if (this.showWeeklyOption) {
      await this.initialCardWeeklyData();
    }
    await this.initialCardMonthlyData();
  }

  getMainDepartments() {
    return new Promise<void>((resolve) => {
      this.masterservice.getDepartmentsProduction(false, 0).subscribe({
        next: (Response: any) => {
          this.mainDepartmentList = Response as MainDepartment[];
          resolve();
        },
        error: (err) => {
          console.error('Error fetching departments:', err);
          resolve();
        },
      });
    });
  }

  selectPeriod() {
    const selectedValue = this.periodId;

    if (selectedValue === 1) {
      this.getDays();
    }
    if (selectedValue === 2) {
      if (!this.showWeeklyOption) {
        this.periodId = 1;
        this.getDays();
        return;
      }
      this.getWeeks();
      this.getProductionCycle();
    }
    if (selectedValue === 3) {
      this.getMonths();
    }
  }

  async getDays() {
    this.periodDayArray = [];
    for (let i = 0; i <= 6; i++) {
      const startDate = moment().subtract(i, 'days').format('YYYY-MM-DD');
      const endDate = moment().subtract(i, 'days').format('YYYY-MM-DD');
      const name = moment().subtract(i, 'days').format('YYYY-MM-DD');
      if (i === 0 && this.isTableData) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.previousStartDate = moment(startDate)
          .subtract(1, 'days')
          .format('YYYY-MM-DD');
        this.previousEndDate = moment(endDate)
          .subtract(1, 'days')
          .format('YYYY-MM-DD');
        this.cycleId = 0;
        // Filter changes must not auto-fetch; the user must click Run Report.
      }
      this.periodDayArray.push({
        value: i,
        name: name,
        startDate: startDate,
        endDate: endDate,
      });
    }
  }

  async getWeeks() {
      const currentDate = moment(); // today
      this.periodArray = [];
  
      for (let i = 0; i < 12; i++) {
        const weekDate = currentDate.clone().subtract(i, 'weeks');
  
        const startDate = weekDate.startOf('week').format('YYYY-MM-DD'); // Sunday
        const endDate = weekDate.endOf('week').format('YYYY-MM-DD'); // Saturday
  
        const weekName = `Week ${i + 1} (${moment(startDate).format('DD MMM')} - ${moment(endDate).format('DD MMM')})`;
  
        if (i === 0 && this.isTableData) {
          this.startDate = startDate;
          this.endDate = endDate;
  
          this.previousStartDate = moment(startDate)
            .subtract(1, 'weeks')
            .startOf('week')
            .format('YYYY-MM-DD');
  
          this.previousEndDate = moment(endDate)
            .subtract(1, 'weeks')
            .endOf('week')
            .format('YYYY-MM-DD');
        }
  
        this.periodArray.push({
          value: i,
          name: weekName,
          startDate: startDate,
          endDate: endDate,
        });
      }
    }  

  async getMonths() {
    const currentDate = moment(); // Current date
    this.periodArray = [];
    for (let i = 0; i < 12; i++) {
      const subtractedDate = currentDate.clone().subtract(i, 'months');
      const startDate = subtractedDate.startOf('month').format('YYYY-MM-DD');
      const endDate = subtractedDate.endOf('month').format('YYYY-MM-DD');
      const monthName = subtractedDate.format('MMMM');
      if (i === 0 && this.isTableData) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.previousStartDate = moment(startDate)
          .subtract(1, 'months')
          .format('YYYY-MM-DD');
        this.previousEndDate = moment(endDate)
          .subtract(1, 'months')
          .format('YYYY-MM-DD');
        this.cycleId = 0;
        // Filter changes must not auto-fetch; the user must click Run Report.
      }
      this.periodArray.push({
        value: i,
        name: monthName,
        startDate: startDate,
        endDate: endDate,
      });
    }
  }

  /*getProductionCycle() {

    this.masterservice.getweekcolors().subscribe((res) => {

      this.weekData = [];
      let colors = res as any[];
      let activeColors = colors.filter((res) => res.active == true);
      activeColors.forEach((res) => {
        this.weekData.push({
          "id": res.productionCycleID,
          "colorName": res.displayName,
          "color": res.color
        })
      })
    })
    this.cycleId = this.weekData[0].id;
    this.startDate = '';
    this.endDate = '';
    this.getStorePerformer();
    this.getEmployeePerformer();
  }*/
  async getProductionCycle() {
    this.weekColorService.getProductionCycleSchedule(this.userInfo.companyID).subscribe((res) => {
      this.weekData = [];
      let colors = res as any[];
      colors.forEach((res) => {
        this.weekData.push({
          id: res.productionCycleId,
          colorName: res.displayName,
          color: res.color,
        });
      });
      if (this.isTableData) {
        this.cycleId = this.weekData[0].id ?? 0;
       // this.startDate = null;
       // this.endDate = null;
        this.previousEndDate = undefined;
        this.previousStartDate = undefined;
        // Filter changes must not auto-fetch; the user must click Run Report.
      }
    });
  }

  async initialCardDailyData() {
    const today = moment().format('YYYY-MM-DD');
    const previousDay = moment().subtract(1, 'days').format('YYYY-MM-DD');
    this.startDate = today;
    this.endDate = this.startDate;
    this.previousStartDate = previousDay;
    this.previousEndDate = this.previousStartDate;

    this.getEmployeeCardPerformer(1);
    this.getStoreCardDailyPerformer(1);
  }

  async initialCardWeeklyData() {
    this.weekColorService.getProductionCycleSchedule(this.userInfo.companyID).subscribe((res: any) => {
      this.weekData = [];
      let colors = res as any[];
      colors.forEach((res) => {
        this.weekData.push({
          id: res.productionCycleId,
          colorName: res.displayName,
          color: res.color,
        });
      });
      this.cycleId = this.weekData[0].id ?? 0;
       // this.startDate = null;
       // this.endDate = null;
        this.previousEndDate = undefined;
        this.previousStartDate = undefined;
        this.getEmployeeCardPerformer(2);
        this.getStoreCardDailyPerformer(2);
    });
  }

  async initialCardMonthlyData() {
    const today = moment();

    const currentMonthStart = today
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD');
    const currentMonthEnd = today.clone().endOf('month').format('YYYY-MM-DD');
    const previousMonthStart = today
      .clone()
      .subtract(1, 'month')
      .startOf('month')
      .format('YYYY-MM-DD');
    const previousMonthEnd = today
      .clone()
      .subtract(1, 'month')
      .endOf('month')
      .format('YYYY-MM-DD');
    this.startDate = currentMonthStart;
    this.endDate = currentMonthEnd;
    this.previousStartDate = previousMonthStart;
    this.previousEndDate = previousMonthEnd;

    this.getEmployeeCardPerformer(3);
    this.getStoreCardDailyPerformer(3);
  }

  formateDate(event: any) {
    const selectedIndex = event.target.value;
    // Daily (periodId 1) options are rendered from periodDayArray; Weekly (2)
    // and Monthly (3) options are both rendered from periodArray. The Monthly
    // case previously fell through to a weekData lookup, which threw
    // "Cannot read properties of undefined (reading 'id')" because weekData is
    // empty in Monthly mode and left the dates unchanged.
    if (this.periodId === 1) {
      if (selectedIndex >= 0 && selectedIndex < this.periodDayArray.length) {
        const selectedPeriod = this.periodDayArray[selectedIndex];
        const selectPrevPeriod = this.periodDayArray[selectedIndex - 1];
        this.startDate = selectedPeriod!.startDate;
        this.endDate = selectedPeriod?.endDate;
        this.cycleId = 0;
        if (selectPrevPeriod) {
          this.previousStartDate = selectPrevPeriod!.startDate;
          this.previousEndDate = selectPrevPeriod!.endDate;
        }
      }
    } else {
      if (selectedIndex >= 0 && selectedIndex < this.periodArray.length) {
        const selectedPeriod = this.periodArray[selectedIndex];
        const selectPrevPeriod = this.periodArray[selectedIndex - 1];
        this.startDate = selectedPeriod!.startDate;
        this.endDate = selectedPeriod?.endDate;
        this.cycleId = 0;
        if (selectPrevPeriod) {
          this.previousStartDate = selectPrevPeriod!.startDate;
          this.previousEndDate = selectPrevPeriod!.endDate;
        }
      }
    }
    // Filter changes must not auto-fetch; the user must click Run Report.
  }

  formateCardDetailDates(event: any, flag: number) {
    let selectedIndex = event.target.value;
    if (flag == 1) {
      if (selectedIndex >= 0 && selectedIndex < this.periodDayArray.length) {
        const selectedPeriod = this.periodDayArray[selectedIndex];
        this.startDate = selectedPeriod!.startDate;
        this.endDate = selectedPeriod?.endDate;
        this.dayStartDate = this.startDate;
        this.dayEndDate = this.endDate;
      }
      if (this.isEmpCard) {
        this.getEmployeeCardPerformer(1);
      } else {
        this.getStoreCardDailyPerformer(1);
      }
    } else {
      if (flag == 3) {
        if (selectedIndex >= 0 && selectedIndex < this.periodArray.length) {
          // Retrieve the object from periodArray using the index
          const selectedPeriod = this.periodArray[selectedIndex];
          this.startDate = selectedPeriod!.startDate;
          this.endDate = selectedPeriod?.endDate;
        }
        if (this.isEmpCard) {
          this.getEmployeeCardPerformer(3);
        } else {
          this.getStoreCardDailyPerformer(3);
        }
      } else {
        if (flag == 2) {
          const selectedWeek = this.weekData[selectedIndex];
          this.cycleId = selectedWeek.id;
          if (this.isEmpCard) {
            this.getEmployeeCardPerformer(2);
          } else {
            this.getStoreCardDailyPerformer(2);
          }
        }
      }
    }
  }

  getTopPerformerData() {
    if (!this.reportHasRun) return;
    if (this.isTableData) {
      if (this.topPerformerTabId === 0) {
        this.getStorePerformer();
      } else {
        this.getEmployeePerformer();
      }
    } else {
      if (this.isEmpCard) {
        this.getEmpDeptWiseCardDetails();
      } else {
        this.getDeptCardDetails();
      }
    }
  }

  async runReport() {
    this.reportHasRun = true;
    if (!this.isTableData) {
      await this.loadCardData();
    }
    this.topPerformerTabChange(this.topPerformerTabId);
    if (this.isTableData) {
      if (this.topPerformerTabId === 0) {
        this.getStorePerformer();
      } else {
        this.getEmployeePerformer();
      }
    }
  }

  getEmployeePerformer() {
    const now = Date.now();
    if (now - this.lastUpdateTime < this.UPDATE_THRESHOLD) {
      return;
    }
    this.lastUpdateTime = now;
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedStartDate = this.datepipe.transform(
      this.previousStartDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedEndDate = this.datepipe.transform(
      this.previousEndDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterservice
      .getEmployeeTopPerformerReport(
        this.userInfo.companyID,
        this.userInfo.userId,
        formattedStartDate!,
        formattedEndDate!,
        prevFormattedStartDate!,
        prevFormattedEndDate!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe({
        next: (res: any) => {
          this.performance = res as any;
          let currentPerformer = this.performance.currentPerformer;
          let lastPerformer = this.performance.lastPerformer;
          currentPerformer.forEach((res: any, index: any) => {
            res.rank = index + 1;
            res.previousRank =
              lastPerformer.findIndex(
                (obj: { createdByUserId: number }) =>
                  obj.createdByUserId === res.createdByUserId
              ) + 1;
            res.position = res.previousRank - res.rank;
          });
          this.performerData = currentPerformer;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  getStorePerformer() {
    const now = Date.now();
    if (now - this.lastUpdateTime < this.UPDATE_THRESHOLD) {
      return;
    }
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedStartDate = this.datepipe.transform(
      this.previousStartDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedEndDate = this.datepipe.transform(
      this.previousEndDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterservice
      .getStoreTopPerformerReport(
        this.userInfo.companyID,
        undefined,
        formattedStartDate!,
        formattedEndDate!,
        prevFormattedStartDate!,
        prevFormattedEndDate!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe({
        next: (res: any) => {
          this.performance = res as any;
          let currentPerformer = this.performance.currentPerformer;
          let lastPerformer = this.performance.lastPerformer;
          currentPerformer.forEach((res: any, index: any) => {
            res.rank = index + 1;
            res.previousRank =
              lastPerformer.findIndex(
                (obj: { storeId: number }) => obj.storeId === res.storeId
              ) + 1;
            res.position = res.previousRank - res.rank;
          });
          this.performerData2 = currentPerformer;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  getEmployeeCardPerformer(value: number) {
    if (value == 1 && !this.deptID) {
      this.deptID = 0;
      this.cycleId = 0;
    }
    if (value == 2 && !this.deptID) {
      this.deptID = 0;
      // this.startDate = null;
      // this.endDate = null;
      // this.previousStartDate = '';
      // this.previousEndDate = '';
    }
    if (value == 3 && !this.deptID) {
      this.deptID = 0;
      this.cycleId = 0;
    }
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedStartDate = this.datepipe.transform(
      this.previousStartDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedEndDate = this.datepipe.transform(
      this.previousEndDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterservice
      .getEmployeeTopPerformerReport(
        this.userInfo.companyID,
        this.userInfo.userId,
        formattedStartDate!,
        formattedEndDate!,
        prevFormattedStartDate!,
        prevFormattedEndDate!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe(
        (res: any) => {
          let currentPerformer = res.currentPerformer;
          if (value == 1) {
            this.performanceEmpDaily = currentPerformer.slice(0, 3);
            this.performanceEmpDaily.forEach(
              (performer: any, index: number) => {
                performer.img = performer.profileFileUrl ? performer.profileFileUrl : 'assets/dashboard/default_performer.png';
                performer.icRank = this.icArray[index];
              }
            );
          } else {
            if (value == 2) {
              this.performanceEmpWeekly = currentPerformer.slice(0, 3);
              this.performanceEmpWeekly.forEach(
                (performer: any, index: number) => {
                  performer.img = performer.profileFileUrl ? performer.profileFileUrl : 'assets/dashboard/default_performer.png';
                  performer.icRank = this.icArray[index];
                }
              );
            } else {
              if (value == 3) {
                this.performanceEmpMonthly = currentPerformer.slice(0, 3);
                this.performanceEmpMonthly.forEach(
                  (performer: any, index: number) => {
                    performer.img = performer.profileFileUrl ? performer.profileFileUrl : 'assets/dashboard/default_performer.png';
                    performer.icRank = this.icArray[index];
                  }
                );
              }
            }
          }
        },
        (err: any) => { }
      );
  }

  getEmpDeptWiseCardDetails() {
     let formattedStartDate: string | null = null;
    let formattedEndDate: string | null = null;
    let cycleId = 0;
    

    switch (this.deptDataFetchCount) {

      case 0: // DAILY
        cycleId = 0;
        this.startDate = moment().startOf('day').toDate();
        this.endDate = moment().endOf('day').toDate();
        formattedStartDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd HH:mm:ss');
        formattedEndDate = this.datepipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss');
        break;

      case 1: // WEEKLY
        cycleId = this.cycleId;
        this.startDate = moment().startOf('week').toDate();
        this.endDate = moment().endOf('week').toDate();
        formattedStartDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd HH:mm:ss');
        formattedEndDate = this.datepipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss');
        break;

      case 2: // MONTHLY
        cycleId = 0;
        this.startDate = moment().startOf('month').toDate();
        this.endDate = moment().endOf('month').toDate();
        formattedStartDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd HH:mm:ss');
        formattedEndDate = this.datepipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss');
        break;
    }

    const prevFormattedStartDate = this.datepipe.transform(
      this.previousStartDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedEndDate = this.datepipe.transform(
      this.previousEndDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterservice
      .getEmployeeTopPerformerReport(
        this.userInfo.companyID,
        this.userInfo.userId,
        formattedStartDate!,
        formattedEndDate!,
        prevFormattedStartDate!,
        prevFormattedEndDate!,
        this.deptID,
        cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe(
        (res: any) => {
          let currentPerformer = res.currentPerformer;
          if (this.deptDataFetchCount == 0) {
            this.performanceEmpDaily = [];
            this.performanceEmpDaily = currentPerformer.slice(0, 3);
            this.performanceEmpDaily.forEach(
              (performer: any, index: number) => {
                performer.img = performer.profileFileUrl ? performer.profileFileUrl : 'assets/dashboard/default_performer.png';
                performer.icRank = this.icArray[index];
              }
            );
            this.deptDataFetchCount++;
          } else {
            if (this.deptDataFetchCount == 1) {
              this.performanceEmpWeekly = currentPerformer.slice(0, 3);
              this.performanceEmpWeekly.forEach(
                (performer: any, index: number) => {
                  performer.img = performer.profileFileUrl ? performer.profileFileUrl : 'assets/dashboard/default_performer.png';
                  performer.icRank = this.icArray[index];
                }
              );
              this.deptDataFetchCount++;
            } else {
              if (this.deptDataFetchCount == 2) {
                this.performanceEmpMonthly = currentPerformer.slice(0, 3);
                this.performanceEmpMonthly.forEach(
                  (performer: any, index: number) => {
                    performer.img =
                      performer.profileFileUrl || 'assets/dashboard/default_performer.png';
                    performer.icRank = this.icArray[index];
                  }
                );
                this.deptDataFetchCount++;
              }
            }
          }
          if (this.deptDataFetchCount <= 2) this.getTopPerformerData();
          if (this.deptDataFetchCount > 2) this.deptDataFetchCount = 0;
        },
        (err: any) => { }
      );
  }

  getStoreCardDailyPerformer(value: number) {
    if (value == 1 && !this.deptID) {
      this.deptID = 0;
      this.cycleId = 0;
    }
    if (value == 2 && !this.deptID) {
      this.deptID = 0;
     // this.startDate = null;
     // this.endDate = null;
    }
    if (value == 3 && !this.deptID) {
      this.deptID = 0;
      this.cycleId = 0;
      this.isItemEntry = false;
    }

    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedStartDate = this.datepipe.transform(
      this.previousStartDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedEndDate = this.datepipe.transform(
      this.previousEndDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterservice
      .getStoreTopPerformerReport(
        this.userInfo.companyID,
        undefined,
        formattedStartDate!,
        formattedEndDate!,
        prevFormattedStartDate!,
        prevFormattedEndDate!,
        this.deptID,
        this.cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe(
        (res: any) => {
          let currentPerformer = res.currentPerformer;
          if (value == 1) {
            this.performanceCardDaily = currentPerformer.slice(0, 3);
            this.performanceCardDaily.forEach(
              (performer: { img: string; icRank: string }, index: number) => {
                performer.img = this.imgArray[index];
                performer.icRank = this.icArray[index];
              }
            );
          } else {
            if (value == 2) {
              this.performanceCardWeekly = currentPerformer.slice(0, 3);
              this.performanceCardWeekly.forEach(
                (performer: { img: string; icRank: string }, index: number) => {
                  performer.img = this.imgArray[index];
                  performer.icRank = this.icArray[index];
                }
              );
            } else {
              if (value == 3) {
                this.performanceCardMonthly = currentPerformer.slice(0, 3);
                this.performanceCardMonthly.forEach(
                  (
                    performer: { img: string; icRank: string },
                    index: number
                  ) => {
                    performer.img = this.imgArray[index];
                    performer.icRank = this.icArray[index];
                  }
                );
              }
            }
          }
        },
        (err: any) => { }
      );
  }

  getDeptCardDetails() {
    let formattedStartDate: string | null = null;
    let formattedEndDate: string | null = null;
    let cycleId = 0;

    switch (this.deptDataFetchCount) {
      case 0: // DAILY
        cycleId = 0;
        this.startDate = moment().startOf('day').toDate();
        this.endDate = moment().endOf('day').toDate();
        formattedStartDate = this.datepipe.transform(
          this.startDate,
          'yyyy-MM-dd HH:mm:ss'
        );
        formattedEndDate = this.datepipe.transform(
          this.endDate,
          'yyyy-MM-dd HH:mm:ss'
        );
        break;

      case 1: // WEEKLY
        cycleId = this.cycleId;
        break;

      case 2: // MONTHLY
        cycleId = 0;
        this.startDate = moment().startOf('month').toDate();
        this.endDate = moment().endOf('month').toDate();
        formattedStartDate = this.datepipe.transform(
          this.startDate,
          'yyyy-MM-dd HH:mm:ss'
        );
        formattedEndDate = this.datepipe.transform(
          this.endDate,
          'yyyy-MM-dd HH:mm:ss'
        );
        break;
    }
    // Assuming isItemEntry is a variable, and its value might be a boolean or a string

    const prevFormattedStartDate = this.datepipe.transform(
      this.previousStartDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const prevFormattedEndDate = this.datepipe.transform(
      this.previousEndDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterservice
      .getStoreTopPerformerReport(
        this.userInfo.companyID,
        undefined,
        formattedStartDate!,
        formattedEndDate!,
        prevFormattedStartDate!,
        prevFormattedEndDate!,
        this.deptID,
        cycleId,
        undefined,
        this.isItemEntry
      )
      .subscribe({
        next: (res: any) => {
          let currentPerformer = res.currentPerformer;
          if (this.deptDataFetchCount == 0) {
            this.performanceCardDaily = [];
            this.performanceCardDaily = currentPerformer.slice(0, 3);
            this.performanceCardDaily.forEach(
              (performer: { img: string; icRank: string }, index: number) => {
                performer.img = this.imgArray[index];
                performer.icRank = this.icArray[index];
              }
            );
            this.deptDataFetchCount++;
          } else {
            if (this.deptDataFetchCount == 1) {
              this.performanceCardWeekly = currentPerformer.slice(0, 3);
              this.performanceCardWeekly.forEach(
                (performer: { img: string; icRank: string }, index: number) => {
                  performer.img = this.imgArray[index];
                  performer.icRank = this.icArray[index];
                }
              );
              this.deptDataFetchCount++;
            } else {
              if (this.deptDataFetchCount == 2) {
                this.performanceCardMonthly = currentPerformer.slice(0, 3);
                this.performanceCardMonthly.forEach(
                  (
                    performer: { img: string; icRank: string },
                    index: number
                  ) => {
                    performer.img = this.imgArray[index];
                    performer.icRank = this.icArray[index];
                  }
                );
                this.deptDataFetchCount++;
              }
            }
          }
          if (this.deptDataFetchCount <= 2) this.getTopPerformerData();
          if (this.deptDataFetchCount > 2) this.deptDataFetchCount = 0;
        },
        error: (err: any) => {},
      });
  }

  private assignCardImages(data: any[], isEmp: boolean) {
    const imgArray = isEmp ? this.empImgArray : this.imgArray;
    data.forEach((performer: any, index: number) => {
      performer.img =
        isEmp && (performer.profileFileUrl && performer.profileFileUrl !== 'null')
          ? performer.profileFileUrl
          : isEmp ? 'assets/dashboard/default_performer.png' : imgArray[index];
      performer.icRank = this.icArray[index];
    });
  }
}
